import type { CategoryValue } from './categories';

export interface Creator {
  id: string;
  name: string;
  nameKo: string;
  nameZh: string;
  folderName: string;
  categories: CategoryValue[];
  followers: number;
  description: string;
  descriptionKo: string;
  descriptionZh: string;
  instagram: string;
  tiktok: string;
  xiaohongshu: string;
}

export const creators: Creator[] = [
  {
    id: 'creator-01',
    name: 'Daeun',
    nameKo: '다은',
    nameZh: '多恩',
    folderName: 'daeun',
    categories: ['beauty', 'lifestyle'],
    followers: 1280000,
    description: 'K-beauty creator specializing in skincare routines and product reviews with a clean, minimal aesthetic.',
    descriptionKo: '클린하고 미니멀한 감성으로 스킨케어 루틴과 제품 리뷰를 전문으로 하는 K-뷰티 크리에이터.',
    descriptionZh: '专注于护肤流程和产品评测的 K-beauty 创作者，风格清新简约。',
    instagram: 'https://www.instagram.com/',
    tiktok: 'https://www.tiktok.com/',
    xiaohongshu: 'https://www.xiaohongshu.com/',
  },
  {
    id: 'creator-02',
    name: 'Yebin',
    nameKo: '예빈',
    nameZh: '艺彬',
    folderName: 'yebin',
    categories: ['fashion', 'beauty'],
    followers: 950000,
    description: 'Fashion and beauty creator with a bold, trend-setting style and eye for unique color palettes.',
    descriptionKo: '트렌드를 선도하는 과감한 스타일과 독특한 컬러 감각이 돋보이는 패션·뷰티 크리에이터.',
    descriptionZh: '以前卫风格和独特色彩感著称的时尚美妆创作者。',
    instagram: 'https://www.instagram.com/',
    tiktok: 'https://www.tiktok.com/',
    xiaohongshu: 'https://www.xiaohongshu.com/',
  },
];